module.exports = __webpack_public_path__ + "img/yaguangmozhenxingdai.min.5c5bf8dd.png";